//router/import-production.js
module.exports = file => () => import('@/views/' + file + '.vue')
